// TEMP WORKAROUND: Manually register transformers before any caching happens
// This fixes the "cached.address.toBase58 is not a function" error
// The auto-registration side effects are being tree-shaken away
// Remove once @solomon-labs/caching or @solomon-labs/transformers is fixed
import { createApp } from "@solomon-apps/shared";
import {
    BigDecimalTransformer,
    BigIntTransformer,
    PublicKeyTransformer,
    TransformerRegistry,
    Uint8ArrayTransformer
} from "@solomon-labs/transformers";

// Force manual registration since side effects are tree-shaken
TransformerRegistry.register(PublicKeyTransformer);
TransformerRegistry.register(BigIntTransformer);
TransformerRegistry.register(BigDecimalTransformer);
TransformerRegistry.register(Uint8ArrayTransformer);

import { Layout } from "./components/Layout";
import { MetricsPage } from "./pages/MetricsPage";

/**
 * Solomon Metrics Website App entry point
 */
void (async (): Promise<void> => {
    await createApp({
        routes: [
            {
                key: "metrics",
                path: "/",
                component: MetricsPage
            }
        ],
        components: {
            layout: Layout
        }
    });
})();
